module.exports = __webpack_public_path__ + "static/media/Roll-Safe-Think-About-It.5801db38.jpg";